import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { useSeo } from '../../lib/seo';
import '../../styles/public.css';

export default function NotFound() {
  useSeo({ title: '页面未找到', description: '您访问的页面不存在。' });
  return (
    <div className="container not-found">
      <p className="not-found-code">404</p>
      <h1 className="not-found-title">页面走散在山雾里了</h1>
      <p className="not-found-desc">您访问的页面不存在，或已被移动到其他位置。</p>
      <Link to="/" className="btn btn-primary">
        <Home size={15} aria-hidden="true" />
        返回首页
      </Link>
    </div>
  );
}
